import { render } from "./DialogConfirm.vue?vue&type=template&id=629772a8&scoped=true&ts=true"
import script from "./DialogConfirm.vue?vue&type=script&lang=ts"
export * from "./DialogConfirm.vue?vue&type=script&lang=ts"

import "./DialogConfirm.vue?vue&type=style&index=0&id=629772a8&lang=scss&scoped=true"

import exportComponent from "/root/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-629772a8"]])

export default __exports__